module.exports = {};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/~/core-js/internals/iterators.js
// module id = 209
// module chunks = 1